import { Loader } from "@/components/common/loader";
import { MultidietPickerCarousel } from "@/features/multidiet-picker/components/multidiet-picker-carousel";
import { MultidietVariantsItem } from "@/features/multidiet-picker/components/multidiet-variants-item";
import useMultidietSetupStore from "@/features/multidiet-picker/store/multidiet-picker.store";
import type { MultidietSetupVariantType } from "@/features/multidiet-picker/types/multidiet-setup.type";

export const MultidietVariants = ({
  layout,
  multidietSetupLabels,
}: {
  layout: "page" | "popup";
  multidietSetupLabels: MultidietSetupVariantType[];
}) => {
  const { isFetching } = useMultidietSetupStore();

  return (
    <div className="relative">
      {isFetching && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/50">
          <Loader />
        </div>
      )}
      <div className="hidden xl:block">
        <div className="flex items-center gap-3">
          {multidietSetupLabels?.map((variant) => {
            return (
              <MultidietVariantsItem
                isBestOffer={variant.type === "STANDARD"}
                key={variant.type + variant.calories}
                layout={layout}
                size={variant.type === "STANDARD" ? "large" : "small"}
                variant={variant}
              />
            );
          })}
        </div>
      </div>
      <div className="w-full items-center gap-3 lg:flex xl:hidden">
        {multidietSetupLabels && (
          <MultidietPickerCarousel
            layout={layout}
            variants={multidietSetupLabels}
          />
        )}
      </div>
    </div>
  );
};
